import { Route, Routes } from "@angular/router";
import { routes } from "src/app/routing/routes";

export class RouteUtilities {

    public static Anonymous(route: Route): boolean {
        return (route?.canActivate?.length ?? 0) > 0;
    }

    public static AnonymousRoute(path: string, routeCollection: Routes | undefined = undefined): boolean {
        const route: Route | undefined = RouteUtilities.fetch(path, routeCollection)
        return (route?.canActivate?.length ?? 0) === 0;
    }

    public static fetch(path: string, routeCollection: Routes | undefined = undefined): Route | undefined {
        routeCollection = routeCollection ?? routes;
        return routeCollection.find(route => route.path === path);
    }
}
